import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.surfaceContainerLowest};
    font-family: ${theme.font.bodyLarge.fontFamily}, sans-serif;

    @media (max-width: 480px) {
      align-items: flex-start;
      padding: ${theme.spacing.level8} ${theme.spacing.level4};
    }
  `}
`;

export const Card = styled.div`
  max-width: 480px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.level9};
  text-align: center;

  @media (max-width: 480px) {
    padding: ${({ theme }) => theme.spacing.level6} ${({ theme }) => theme.spacing.level4};
  }
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.font.headlineMedium.fontSize};
    font-weight: 700;
    color: ${theme.colors.success};
    margin: 0 0 ${theme.spacing.level4};
  `}
`;

export const Message = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.bodyLarge.fontSize};
    color: ${theme.colors.onSurfaceVariant};
    margin: 0;
  `}
`;
